// @ts-nocheck
import { getCmsParams, pathURls } from 'Config';
import { axiosHelper } from 'Services/AxiosHelper';
import { GetCmsModel } from 'Models';
import { getApiGWTokenCookie } from 'Utils';

//const command = 'cms.getCMSTranslations';

const GetTokenForLogin = async () =>
  (
    await axiosHelper({
      method: 'post',
      data: {
        command: 'login.lgU&pvv',
        id: 'testapi',
        password: '123456',
      },
      isTmobLabsUrl: true,
    })
  ).data;

export default GetTokenForLogin;
